import React, { useEffect, useRef } from "react";
import { Layout, Row, Col, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setLanguage } from '../../redux/actions/selectedLanguageAction.js';
import Navbar from '../../Navbar.js';
import Footer from '../footerComponent/Footer.js';
import { openNotification, getInitials } from "../../utilities.js";
import { CustomAxios } from "../../service/axios.js";
import { setUserDetails, setAccessibleApplications } from "../../redux/actions/landingPageAction.js";
import "./selectedLang.css"
import SurveyInfo from "../SurveyInfo/SurveyInfo.js";
import { useMediaQuery } from "react-responsive";
const { Content } = Layout;

const LanguageSelectionPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const userDetails = useSelector((state) => state.landingPage.userDetails);

  const defaultApplications = ["IT Portal", "Other Applications", "Andere Applicatie", "Otra Aplicación", "Autre Application", "Weitere Anwendungen", "其他应用程序", "その他のアプリケーション"];

  const languages = [
    { label: 'Aa', icon: 'English' },
    { label: '漢字', icon: 'Chinese' },
    { label: 'Aa', icon: 'Dutch' },
    { label: 'Àà', icon: 'French' },
    { label: 'Aá', icon: 'Spanish' },
    { label: 'Ää', icon: 'German' },
    { label: '日本', icon: 'Japanese' },
  ];

  const handleLanguageSelect = (language) => {
    dispatch(setLanguage(language));
  };
  useEffect(() => {
    const fetchUserDetails = async () => {
      if (userDetails) return;
      try {
        const response = await CustomAxios("/me", "GET");
        if (response.status === 200) {
          dispatch(setUserDetails(response.data));
          // console.log("User details:", response.data);
        }
      } catch (err) {
        openNotification(
          "error",
          "Failed to fetch user details. Please try again.",
          "custom-notification"
        );
      }
    };

    fetchUserDetails();
  }, [dispatch, userDetails?.email]);

  useEffect(() => {
    const fetchAccessibleApplications = async () => {
      try {
        const response = await CustomAxios("/user-access", "GET");
        if (response.status === 200) {
          const apps = response.data.applications || [];
          dispatch(setAccessibleApplications([...defaultApplications, ...apps]));
        } else {
          dispatch(setAccessibleApplications(defaultApplications));
        }
      } catch (error) {
        console.error("Error loading accessible applications:", error);
        dispatch(setAccessibleApplications(defaultApplications));
      }
    };

    if (userDetails?.email) fetchAccessibleApplications();
  }, [dispatch, userDetails?.email]);

  return (
    <Layout>
      <Navbar />
      <Content>
        <div className="content-page">
          <Row className="lang-survey" gutter={0} style={{ borderTop: "1.3px solid rgba(128, 128, 128,0.5)", }}>

            {/* <SurveyInfo/> */}
            {!isMobile && <SurveyInfo />}


            <Col span={18} className="language-page" style={{ borderLeft: "1.3px solid rgba(128, 128, 128,0.5)", }}>
              <div className="window-frame">
                <div className="language-frame">
                  <h3 className="textstyle">Choose your preferred language:</h3>
                </div>
                <Row gutter={8} >
                  {languages.map((language, index) => (
                    <Col xs={12} sm={6} md={3} key={index} className="languagebutton">


                      <Button
                        type={selectedLanguage === language.icon ? "primary" : "default"}
                        className="language-button" // Apply CSS class instead of inline styles
                        onClick={() => handleLanguageSelect(language.icon)}
                      >
                        <div>{language.label}</div>
                        <div>{language.icon}</div>
                      </Button>
                    </Col>
                  ))}
                </Row>
              </div>
              <Footer
                onBack={() => navigate('/itux-happiness-survey')}
                onNext={() => navigate('/question')}
                nextDisabled={!selectedLanguage}
              />
            </Col>
          </Row>
        </div>
      </Content>
    </Layout>
  );
};

export default LanguageSelectionPage;
